@if (!authService.isAuthenticated) {
<div class="flex md:items-center md:justify-center min-h-screen md:bg-metro-blue pt-safe">
  <!-- Contenedor principal: full width en mobile, tarjeta centrada en tablet/escritorio -->
  <div class="w-full p-3 md:max-w-md md:bg-white md:rounded-xl md:shadow-lg md:p-8 mt-12">

    <!-- Logo / Title -->
    <div class="text-center">
      <img [src]="logoSrc" alt="Wine Passport"
        class="mx-auto max-w-[220px] md:max-w-[260px] w-full mb-2 drop-shadow-sm cursor-pointer">

      <h2 class="mt-2 text-lg font-semibold tracking-wide text-metro-blue-secondary">
        {{ '::Login' | abpLocalization }}
      </h2>
    </div>

    <!-- Form -->
    <form class="mt-8 space-y-4" [formGroup]="loginForm" (ngSubmit)="onSubmit()">

      <!-- Email -->
      <app-metro-form-input
        formControlName="username"
        [placeholder]="'Email'"
        size="md"
        type="text">
      </app-metro-form-input>

      <!-- Password -->
      <div class="mt-2">
        <app-metro-form-input
          formControlName="password"
          [placeholder]="'Password'"
          size="md"
          type="password">
        </app-metro-form-input>
      </div>

      <!-- Forgot Password -->
      <div class="text-center text-sm text-metro-blue-secondary">
        <a routerLink="/account/forgot-password" class="hover:underline">{{'::ForgotPassword' | abpLocalization}}</a>
      </div>

      <!-- Submit Button -->
      <app-metro-button
        class="w-full block"
        [fullWidth]="true"
        variant="custom"
        [customClass]="'bg-metro-blue-secondary text-metro-secondary'"
        text="{{ (inProgress ? '::SigningIn' : '::Login') | abpLocalization }}"
        type="submit"
        [disabled]="loginForm.invalid || inProgress">
      </app-metro-button>
    </form>

    <!-- Or continue with -->
    <div class="mt-6 text-center text-sm text-metro-blue-secondary">
      {{'::OrContinueWith' | abpLocalization}}
    </div>

    <!-- Social Buttons -->
    <div class="mt-2 flex justify-center">
      <app-metro-button 
        class="w-full block"
        [fullWidth]="true"
        variant="secondary" 
        [icon]="iconGoogle" 
        iconColor="#4285F4" 
        (click)="loginWithGoogle()" 
        text="Google">
      </app-metro-button>
    </div>

  </div>
</div>
}
